// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"fb25b585","87":"d06bea82","213":"ec341b11","223":"f881b08a","246":"d3608ce1"}[chunkId] + ".chunk.js";
};